import { ChunkNodeMO } from './ChunkNodeMO';
import { ChunkDataMO } from './ChunkDataMO';
import { WordTypeCountMO } from './WordTypeCountMO';
import { WordTypeScoreMO } from './WordTypeScoreMO';
import { ParagraphMO } from './ParagraphMO';

export class ChunkListMO {
	public head: ChunkNodeMO;
	public length: number;
	public wordTypeCount: WordTypeCountMO;
	public wordTypeScore: WordTypeScoreMO;
	public contentWordCount: number;
	public lastLoadedParagraphIndex: number;
	public nodeProcessed: number;
	public paragraphMOs: ParagraphMO[];
	public chunks: ChunkNodeMO[];
	public isFewWordCount: boolean;

	constructor() {
		this.head = null;
		this.length = 0;
		this.wordTypeCount = new WordTypeCountMO();
		this.wordTypeScore = new WordTypeScoreMO();
		this.contentWordCount = 0;
		this.lastLoadedParagraphIndex = 0;
		this.paragraphMOs = [];
		this.isFewWordCount = false;
		this.chunks = [];
	}

	addFirst(chunkDataMO: ChunkDataMO) {
		this.head = new ChunkNodeMO(0, chunkDataMO, this.head);
	}

	addLast(chunkDataMO: ChunkDataMO) {
		if (this.head === null) {
			this.addFirst(chunkDataMO);
			this.chunks.push(this.head);
		} else {
			let temp: ChunkNodeMO = this.head;
			while (temp.next !== null) {
				temp = temp.next;
			}

			temp.next = new ChunkNodeMO(temp.index + 1, chunkDataMO);
			this.chunks.push(temp.next);
		}
		this.length += 1;
	}

	updateChunkAtIndex(index: number, chunkDataMO: ChunkDataMO) {
		let temp: ChunkNodeMO = this.head;

		while (temp !== null && index <= temp.index) {
			if (temp.index === index) {
				temp.data = chunkDataMO;
				break;
			}

			temp = temp.next;
		}
	}

	getChunkAtIndex(index: number) {
		let temp: ChunkNodeMO = this.head;

		while (temp !== null) {
			if (temp.index === index) {
				return temp;
			}

			temp = temp.next;
		}

		return null;
	}

	queryChunks() {
		let temp: ChunkNodeMO = this.head;
		while (temp !== null) {
			temp = temp.next;
		}
	}

	clone(chunkListMO: ChunkListMO) {
		this.length = chunkListMO.length;
		this.wordTypeCount = chunkListMO.wordTypeCount;
		this.wordTypeScore = chunkListMO.wordTypeScore;
		this.contentWordCount = chunkListMO.contentWordCount;
		this.lastLoadedParagraphIndex = chunkListMO.lastLoadedParagraphIndex;
		this.paragraphMOs = chunkListMO.paragraphMOs;
		this.isFewWordCount = this.contentWordCount < 100;
	}
}
